import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import {initReactI18next} from "react-i18next";
import {prepareRequest} from "./http";

const translationsPath =
		process.env.NODE_ENV === "development"
				? "/locales/{{lng}}/translations.json"
				: prepareRequest("/upload/locales/{{lng}}/translations.json");

console.debug(`loading translations from ${translationsPath}`);

i18n
		.use(Backend)
		.use(LanguageDetector)
		.use(initReactI18next)
		.init({
			detection: {
				order: ["navigator", "querystring", "cookie", "localStorage", "sessionStorage", "htmlTag"],
			},
			backend: {
				loadPath: translationsPath,
			},
			fallbackLng: "en",
			supportedLngs: ["en", "it"],
			load: "languageOnly",
			ns: "translations",
			debug: process.env.NODE_ENV === "development",
			defaultNS: "translations",
		});

export default i18n;